export const isNotEmpty = (input: string | number | null) => {
  return !!input
}
